/**
 * @generated SignedSource<<c92dc947ed605f938949b707218938e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationFranceConnectForm_franceConnectAuth",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signInUrl",
      "storageKey": null
    }
  ],
  "type": "SsoOpenidAuthenticationConfig",
  "abstractKey": null
};

node.hash = "0bdaad53d608e541a8658e12bcf83ec5";

module.exports = node;
